import { KeyboardDatePicker } from "@material-ui/pickers";

const FormikDatePicker = ({ field, form, ...other }: any) => {
  const currentError = form.errors[field.name];
  if (!!currentError) console.log(currentError);
  return (
    <KeyboardDatePicker
      name={field.name}
      value={field.value}
      format="dd/MM/yyyy"
      label="Data"
      helperText={!!currentError ? "Data Inválida" : null}
      error={Boolean(currentError)}
      KeyboardButtonProps={{
        'aria-label': 'change date',
      }}
      InputLabelProps={{
        shrink: true
      }}
      onError={error => {
        // handle as a side effect
        if (error !== currentError) {
          form.setFieldError(field.name, error);
        }
      }}
      cancelLabel="Cancelar"
      // if you are using custom validation schema you probably want to pass `true` as third argument
      onChange={date => form.setFieldValue(field.name, date, true)}
      disablePast
      {...other}
    />
  );
}

export default FormikDatePicker;